<div class="header">
  <mn-svg name="logo" />
  <mn-button aEvent="menu_close" (clicked)="close()">
    <mn-svg name="close" />
  </mn-button>
</div>
<div class="switchers f-c">
  @for (switcher of switchers; track switcher.text) {
    <div>
      <span class="t-s-h c-se m-we">{{ switcher.text + ".title" | mnTranslate }}</span>
      <mn-switcher mnClickArea data-ui-sound [value]="switcher.value()" (valueChange)="switcher.fn()" />
    </div>
  }
</div>
<div class="items f-c">
  @for (item of items(); track item.text) {
    <div data-ui-sound [mnAnalyticsClick]="'menu_item_' + item.text" (click)="select($event, item.index)">
      <mn-svg class="c-p" [name]="item.icon" />
      <span class="t-s-h c-se m-we">{{ item.text + ".title" | mnTranslate }}</span>
    </div>
  }
</div>
